import 'bootstrap';
import React from 'react';
import ReactDOM from 'react-dom';
import './index.scss';
import * as serviceWorker from './serviceWorker';
import App from './App';

const getUrlParameter = function getUrlParameter(sParam) {
  var sPageURL = window.location.search.substring(1),
      sURLVariables = sPageURL.split('&'),
      sParameterName,
      i;

  for (i = 0; i < sURLVariables.length; i++) {
      sParameterName = sURLVariables[i].split('=');

      if (sParameterName[0] === sParam) {
          return sParameterName[1] === undefined ? "" : decodeURIComponent(sParameterName[1]);
      }
  }
};

const getIssueId = function() {
  let returnVal = getUrlParameter("issueid");
  if(typeof(returnVal) === "undefined" || returnVal === "undefined") {
    returnVal = "";
  }
  if(!returnVal.startsWith("ytt_")) {
    returnVal = "";
  } 
  return returnVal;
}

const getArticleId = function() {
  let returnVal = getUrlParameter("articleid");
  if(typeof(returnVal) === "undefined" || returnVal === "undefined") {
    returnVal = "";
  }
  if(!returnVal.startsWith("a_")) {
    returnVal = "";
  } 
  return returnVal;
}

const getPage = function() {
  let returnVal = getUrlParameter("page");
  const defaultPage = "";
  let validPages = ["library", "search", "home", "magazine", "article", "video"]
  if(typeof(returnVal) === "undefined" || returnVal === "undefined") {
    returnVal = defaultPage;
  }
  if(validPages.indexOf(returnVal) === -1) {
    returnVal = defaultPage;
  } 
  return returnVal;
}

// Define user's language. Different browsers have the user locale defined
// on different fields on the `navigator` object, so we make sure to account
// for these different by checking all of them
const language =
  (window.navigator.languages && window.navigator.languages[0]) ||
  window.navigator['language'] ||
  window.navigator['userLanguage'];

// Split locales with a region code
let languageWithoutRegionCode = language.toLowerCase().split(/[_-]+/)[0];

// Check to see if language is set in url
const langParam = getUrlParameter('lang') ? getUrlParameter('lang') : "";

if (languageWithoutRegionCode !== ""){
  if (languageWithoutRegionCode !== "en" && languageWithoutRegionCode !== "fr" && languageWithoutRegionCode !== "ar" && languageWithoutRegionCode !== "de" && languageWithoutRegionCode !== "ja"){
    languageWithoutRegionCode = "en";
  }
}

ReactDOM.render(
  <App localeUrl={langParam} localeBrowser={languageWithoutRegionCode} urlPage={getPage()} urlArticle={getArticleId()} urlIssue={getIssueId()}/>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
